// extracted by mini-css-extract-plugin
module.exports = {"section":"article-apps_section__7Ri0v","apps":"article-apps_apps__iSQ6y","light":"article-apps_light__bj1zq","dark":"article-apps_dark__pdrzs","app":"article-apps_app__7cPie"};